export const SET_ORIGIN = "SET_ORIGIN";
export const SET_ORIGINS = "SET_ORIGINS";
export const ADD_ORIGIN = "ADD_ORIGIN";
export const DELETE_ORIGIN = "DELETE_ORIGIN";
export const UPDATE_ORIGIN = "UPDATE_ORIGIN";
export const SET_ORIGIN_SELECTED = "SET_ORIGIN_SELECTED";
export const RESET_ORIGINS = "RESET_ORIGINS";
